import { z } from 'zod';
import { userDtoSchema } from '../users/user.schemas.js';

export const groupRuleDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const createGroupRuleSchema = z.object({
  name: z.string().trim().min(1).max(100),
});

export const updateGroupRuleSchema = z.object({
  name: z.string().trim().min(1).max(100),
});

export const groupRuleDetailSchema = z.object({
  groupRule: groupRuleDtoSchema,
  members: z.array(userDtoSchema),
});

export const setGroupRuleMembersSchema = z.object({
  userIds: z.array(z.string().uuid()),
});

export type GroupRuleDto = z.infer<typeof groupRuleDtoSchema>;
export type CreateGroupRuleInput = z.infer<typeof createGroupRuleSchema>;
export type UpdateGroupRuleInput = z.infer<typeof updateGroupRuleSchema>;
export type GroupRuleDetailDto = z.infer<typeof groupRuleDetailSchema>;
export type SetGroupRuleMembersInput = z.infer<typeof setGroupRuleMembersSchema>;
